<template>
  <div class="header">
    <div class="container_top">
      <div class="container_top_center">
        <span><i class="el-icon-message"></i>info@sibaida.com</span>
        <span><i class="el-icon-phone-outline"></i>010-5913-9600</span>
      </div>
    </div>
    <nav
      class="navbar navbar-default navbar-fixed-top"
      style="background: #fff"
    >
      <div class="container-fluid">
        <div class="navbar-header" style="position: relative">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
            ref="showBtn"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="#">
            <img
              src="../assets/logo.png"
              style="width: 100%; height: 100%; cursor: pointer"
              alt=""
              @click="toHome"
            />
          </a>
          <div class="contain__tag--mini">"专精特新" 中小企业</div>
        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav">
            <li
              class="dropdown"
              v-for="(item, index) in navbar"
              :key="index"
              @click="navbarClick(item, index)"
            >
              <a
                style="color: #0171bb; font-weight: bold; font-size: 15px"
                class="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                :aria-haspopup="false"
                :aria-expanded="false"
                >{{ item.chinese
                }}<span
                  class="caret"
                  v-show="index == 1"
                  style="margin-left: 8px"
                ></span
              ></a>
              <ul class="dropdown-menu" v-show="item.children">
                <li
                  v-for="(items, indexs) in item.children"
                  :key="indexs"
                  @click="childrenLi(items, indexs)"
                >
                  <a
                    href="#"
                    style="color: #0171bb; font-weight: bold; font-size: 15px"
                    >{{ items.name }}</a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="container">
      <div class="left">
        <img v-lazy="require('../assets/logo.png')" alt="" style="cursor: pointer" @click="toHome"/>
      </div>
      <div class="contain__tag">"专精特新" 中小企业</div>
      <div class="right">
        <div
          v-for="(item, index) in navbar"
          :key="index"
          @mouseenter="mouseenter(index)"
          @mouseleave="mouseleave(index)"
          @click="navbarClick(item, index)"
          :class="{ active1: index == ids }"
          :style="{ position: item.children ? 'relative' : '' }"
        >
          <div class="chinese">{{ item.chinese }}</div>
          <div class="eng">{{ item.eng }}</div>
          <div class="ul bja0HO5x__navber-2" v-if="item.children && show">
            <div
              class="li"
              v-for="(items, indexs) in item.children"
              :class="{ childredActive: indexs == childIds }"
              :key="indexs"
              @click="childrenLi(items, indexs)"
            >
              <div>{{ items.name }}</div>
              <div style="font-size: 12px">{{ items.eng }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "topHeader",
  data() {
    return {
      ids: 0,
      childIds: null,
      show: false,
      navbar: [
        {
          chinese: "首页",
          eng: "Home",
          url: "homecontent",
        },
        {
          chinese: "解决方案",
          eng: "Business Solutions",
          url: "Solution",
          children: [
            {
              name: "政企园区",
              eng: 'Corporate Campus',
              url: "GovernmentEnterprisePark",
            },
            {
              name: "产业园区",
              eng: "Industrial Park",
              url: "productPark",
            },
            {
              name: "“碳中和”园区",
              eng: 'Carbon-neutral Campus',
              url: "carbinPark",
            },
            {
              name: "智慧无人仓",
              eng: 'Smart Warehouse',
              url: "wisdomSmartWarehouse",
            },
          ],
        },
        {
          chinese: "核心产品",
          eng: "Key Products",
          url: "ProductCenter",
        },
        {
          chinese: "技术能力",
          eng: "Technical Capabilities",
          url: "TechnicAlability",
        },
        {
          chinese: "公司介绍",
          eng: "About Us",
          url: "CompanyIntroduction",
        },
      ],
    };
  },
  props: {
    curPageId: {
      type: String,
      default: "homecontent",
    },
  },
  watch: {
    curPageId: {
      handler: function (val, oldVal) {
        switch (val) {
          case "homecontent":
            this.ids = 0;
            break;
          case "GovernmentEnterprisePark":
            this.ids = 1;
            break;
          case "productPark":
            this.ids = 1;
            break;
          case "carbinPark":
            this.ids = 1;
            break;
          case "wisdomSmartWarehouse":
            this.ids = 1;
            break;
          case "ProductCenter":
            this.ids = 2;
            break;
          case "TechnicAlability":
            this.ids = 3;
            break;
          case "CompanyIntroduction":
            this.ids = 4;
            break;
        }
      },
      deep: true,
    },
  },
  methods: {
    toHome() {
      this.$emit("changeViewFun", 'homecontent');
    },
    navbarClick(item, idx) {
      this.ids = idx;
      if (idx !== 1) {
        this.$emit("changeViewFun", item.url);
        this.childIds = null;
        this.$refs["showBtn"].click();
        document.documentElement.scrollTop = 0;
      }
    },
    mouseenter(index) {
      if (index == 1) {
        this.show = true;
      }
    },
    mouseleave() {
      this.show = false;
    },
    childrenLi(item, idx) {
      this.childIds = idx;
      this.$emit("changeViewFun", item.url);
      this.$refs["showBtn"].click();
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style scoped>
.contain__tag {
  position: absolute;
  top: 50%;
  left: 230px;
  transform: translateY(-50%);
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.contain__tag--mini {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: red;
  font-size: 14px;
  font-weight: bold;
  left: 114px;
}
.navbar {
  margin-bottom: 0;
}
.fixed {
  display: none;
}
.header {
  width: 100%;
  justify-content: center;
}
@media (max-width: 425px) {
}
.container {
  position: relative;
  width: 100%;
  height: 100px;
  margin: 0 auto;
  padding: 0;
}
@media screen and (min-width: 569px) and (max-width: 813px) {
  .container {
    width: 100%;
  }
  .chinese {
    font-size: 14px;
  }
  .eng {
    font-size: 10px;
  }
  .right > div {
    width: 130px;
  }
  .right > div:hover {
    background-color: #0171bb;
    color: #fff;
  }
  .left {
    width: 170px;
  }
}
@media screen and (min-width: 1024px) {
  .container {
    width: 100%;
  }
  .chinese {
    font-size: 16px;
  }
  .eng {
    font-size: 12px;
  }
  .right > div {
    width: 140px;
  }
  .ul {
    width: 360px;
  }
}
@media screen and (min-width: 1366px) {
  .container {
    width: 1200px;
  }
  .chinese {
    font-size: 18px;
  }
  .eng {
    font-size: 12px;
  }
  .right > div {
    width: 150px;
  }
  .left {
    width: 230px;
  }
  .ul {
    width: 480px;
  }
}
@media (min-width: 750px) {
  .chinese {
    font-size: 14px;
  }
  .eng {
    font-size: 10px;
  }
  .right > div {
    width: 130px;
  }
}
@media (min-width: 1000px) {
  .container {
    width: 970px;
  }
  .chinese {
    font-size: 16px;
  }
  .eng {
    font-size: 12px;
  }
  .right > div {
    width: 140px;
  }
  .ul {
    width: 360px;
  }
}
@media (min-width: 1280px) {
  .contain__tag {
    left: 270px;
  }
  .container {
    width: 1200px;
  }
  .chinese {
    font-size: 18px;
  }
  .eng {
    font-size: 12px;
  }
  .ul {
    width: 480px;
  }
}
.left {
  float: left;
  display: flex;
  align-items: center;
  text-align: center;
  height: 100%;
}
.left > img {
  margin: 0 auto;
}
.right {
  display: flex;
  height: 100%;
  width: 60%;
  float: right;
  min-width: 590px;
  /* flex: 1; */
}
.right > div {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  flex: 1;
}

@media (max-width: 810px) {
  .container_top {
    display: none;
  }
}
.right > div:hover {
  background-color: rgba(1, 113, 187, 0.8);
  color: #fff;
}
.active1 {
  background-color: #0171bb;
  color: #fff;
}

.active1:hover {
  background-color: #0171bb !important;
}
.chinese {
  font-weight: bold;
}
.ul {
  position: absolute;
  top: 100px;
  left: 0;
  z-index: 99;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: flex;
  width: 400%;
}
.li {
  width: 100%;
  color: #fff;
  background-color: #0171bb;
  font-size: 13px;
}
.li:hover {
  background-color: rgba(255, 255, 255,0.2);
}
/* .childredActive {
  background-color: #f9ae3b;
} */
.childredActive:hover {
  /* background-color: #f9ae3b; */
}
.el-menu-demo {
  height: 100%;
}
.container_top {
  width: 100%;
  height: 30px;
  background: #f1f1f1;
  box-sizing: border-box;
}
.container_top_center {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  line-height: 30px;
}
.container_top_center > span:nth-of-type(1) {
  border-right: 2px solid #d9d9d9;
}
.container_top_center > span {
  padding-right: 20px;
  font-size: 16px;
  color: #888888;
}
.container_top_center > span:nth-of-type(2) {
  padding-left: 18px;
}
.container_top_center > span i {
  margin-right: 10px;
  color: #999;
}
@media (max-width: 1200px) {
  .right {
    justify-content: space-evenly;
  }
}
/* 当页面宽度大于425px*/
@media screen and (min-width: 810px) {
  .navbar {
    display: none;
  }
}
/* 当页面宽度小于425px*/
@media screen and (max-width: 810px) {
  .container {
    display: none;
  }
}
@media (max-width: 425px) {
  .right > div {
    font-size: 15px;
  }
  .navbar-brand {
    width: 30%;
  }
  .header {
    height: 50px;
  }
  .navbar-default .navbar-nav .open .dropdown-menu>li>a {
    line-height: 26px;
  }
}

.right .bja0HO5x__navber-2 {
  /* top: 101px; */
  border-top: solid 1px transparent;
}
.right .bja0HO5x__navber-2::before {
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0171bb;
  z-index: -1;
  content: '';
}
.bja0HO5x__navber-2 .li {
  border-right: solid 1px rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 50px;
  line-height: 16px;
}

.bja0HO5x__navber-2 .li:last-child {
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/components/topHeader.vue